<template>
	<div v-show="selfDisplay" class="com_popup">
		<transition 
			name="fade_transition"
		>
			<div v-if="display" class="in_bg"></div>
		</transition>
		<transition 
			@before-enter="beforeEnter"
			@after-leave="afterLeave"
			name="popup_transform_transition"
		>
			<div v-if="display" class="in_box" :style="{width: width + 'px'}">
				<div class="in_head">
					{{ title }}
					<!-- <span v-if="title=='充值'" style="font-size: 12px; color: red;font-weight: 400;">
						(如操作失误需扣除返还请联系科飞管理员)
					</span> -->
					<i class="el-icon-close" @click="handleCancelClick"></i>
				</div>
				<div class="in_bd">
					<slot></slot>
				</div>
				<div class="in_ft clear_both">
					<el-button v-if="expandBtnDisplay" type="primary" style="float: left;" @click="handleExpandClick">{{ expandBtnText || '' }}</el-button>
					<el-button v-if="cancelBtnDisplay" @click="handleCancelClick">{{ cancelBtnText || '取消' }}</el-button>
					<el-button v-if="confirmBtnDisplay" type="primary" @click="handleConfirmClick">{{ confirmBtnText || '确定' }}</el-button>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			width: {
				type: Number,
				default: 880
			},
			title: String,
			expandBtnText: String,
			expandBtnDisplay: {
				type: Boolean,
				default: false
			},
			cancelBtnText: String,
			confirmBtnText: String,
			cancelBtnDisplay: {
				type: Boolean,
				default: true
			},
			confirmBtnDisplay: {
				type: Boolean,
				default: true
			}
		},
		data () {
			return {
				selfDisplay: false
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		methods: {
			handleExpandClick() {
				this.$emit("expandClick");
			},
			handleCancelClick () {
				this.$emit("changeDisplay", false);
			},
			handleConfirmClick () {
				this.$emit("confirmClick");
			},
			beforeEnter() {
				this.selfDisplay = true;
			},
			afterLeave() {
				this.selfDisplay = false;
			}
		}
	}
</script>

<style>
	.com_popup{ position: absolute;z-index: 99;width: 100%;height: 100%;top: 0;left: 0; }
	.com_popup .in_bg{ width: 100%;height: 100%;background: rgba(0, 0, 0, 0.5); }
	.com_popup .in_box{ position: absolute;top: 50%;left: 50%;border-radius: 5px;background: #fff;transform: translate(-50%, -50%); }
	.com_popup .in_head{ position: relative;padding: 5px 35px 5px 15px;font-size: 18px;color: #5f6468;line-height: 40px; }
	.com_popup .in_head .el-icon-close{ position: absolute;top: 16px;right: 15px;cursor: pointer; }
	.com_popup .in_bd{ max-height: 480px;border-top: 1px solid #d7d7d7;border-bottom: 1px solid #d7d7d7;overflow-x: auto;overflow-y: auto; }
	.com_popup .in_ft{ height: 46px;padding: 5px 15px;font-size: 0;text-align: right; }
</style>
